// Live handle to the current room's GameContext, for overlay scenes (HUD,
// pause, debug) that poll gameplay state. Null between rooms and outside runs.

import type { GameContext } from './contracts';

export const session: { ctx: GameContext | null } = { ctx: null };
